export default __webpack_public_path__ + "static/media/envelop.20572298.svg";